import { createSelector, createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    isMobile: false,
    modal: {
      isOpen: false,
      name: '',
    },
    stepper: {
      current: null,
      count: null,
      title: null,
    },
    badger: {
      error: null,
      title: '',
      message: '',
      isOpen: false,
      action: null,
      key: null,
      i18nParams: {},
    },
    newsFeed: {
      isOpen: true,
    },
    dateRange: '24h',
  },
  reducers: {
    setStep: (state, action) => {
      state.stepper = { ...state.stepper, ...action.payload };
    },
    openModal: (state, action) => {
      state.modal.isOpen = true;
      state.modal.name = action.payload;
    },
    closeModal: (state) => {
      state.modal.isOpen = false;
      state.modal.name = null;
    },
    openBadger: (state, action) => {
      state.badger.isOpen = true;
      state.badger.message = action.payload.message;
      state.badger.key = action.payload.key;
      state.badger.title = action.payload.title;
      state.badger.i18nParams = action.payload.i18nParams;
      state.badger.action = action.payload.action;
      state.badger.error = !!action.payload.error;
    },
    closeBadger: (state) => {
      state.badger.isOpen = false;
      state.badger.title = '';
      state.badger.message = '';
      state.badger.action = null;
      state.badger.i18nParams = {};
      state.badger.key = null;
      state.badger.error = null;
    },
    setDateRange: (state, action) => {
      state.dateRange = action.payload;
    },
    toggleNewsFeed: (state) => {
      state.newsFeed.isOpen = !state.newsFeed.isOpen;
    },
    toggleIsMobile: (state, action) => {
      state.isMobile = action.payload;
      if (state.isMobile) {
        state.newsFeed.isOpen = false;
      }
    },
  },
});

export const selectUI = createSelector(
  (state) => ({
    stepper: state.ui.stepper,
    isMobile: state.ui.isMobile,
  }),
  (state) => state,
);

export const selectBadger = createSelector(
  (state) => ({
    badger: state.ui.badger,
  }),
  (state) => state,
);

export const selectModal = createSelector(
  (state) => ({
    modal: state.ui.modal,
  }),
  (state) => state,
);

export const selectDateRange = createSelector(
  (state) => ({
    dateRange: state.ui.dateRange,
  }),
  (state) => state,
);

export const selectNewsFeed = createSelector(
  (state) => ({
    newsFeed: state.ui.newsFeed,
  }),
  (state) => state,
);

export const {
  openModal,
  closeModal,
  openBadger,
  closeBadger,
  toggleNewsFeed,
  setStep,
  setDateRange,
  toggleIsMobile,
} = uiSlice.actions;

export default uiSlice.reducer;
